import { GateXorIcon } from './GateXorIcon';

/**
 * author: Nick
 * id AFA3ABA2-1237-417E-8277-8509C7A58C1C
 * name gate-xor
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-xor.svg
 * tags
 */
export const LogicGateXorIcon = GateXorIcon;
export default LogicGateXorIcon